module.exports = __webpack_public_path__ + "img/icon7.67ae483d.png";